import _ from 'lodash';
import globalStore from '$$globalStore';
import tasksHelpers from '$$store/tasks/helpers';
import GanttWorker from '../workers/GanttWorker';

const prepareNewLinkData = link => ({
  id: link.id || tasksHelpers.uid(),
  source: link.source,
  target: link.target,
  gantt_id: link.gantt_id,
  type: link.type,
  lag: link.lag,
});

export default async function (links, fromGantt) {
  const tasksMap = globalStore.getters['tasksModel/tasksByIds'];

  const createdLinkMap = {};
  const updatedTaskMap = {};
  const updatedTasksForCommit = [];
  const createdLinksForCommit = [];
  let refreshOverload = false;

  // Links creation
  links.forEach(link => {
    const linkData = prepareNewLinkData(link);

    createdLinkMap[linkData.id] = _.omit(linkData, 'id');
    createdLinksForCommit.push(linkData);
  });

  // Run worker (if needed)
  const needGanttWorker = !fromGantt && createdLinksForCommit.length;
  let ganttWorkerData = null;

  if (needGanttWorker) {
    ganttWorkerData = await GanttWorker.calculate(createdLinksForCommit, 'changeLinks', 'addLinks');
    fromGantt = false;
  }

  createdLinksForCommit.forEach(link => {
    if (ganttWorkerData && ganttWorkerData.diff.linksToAdd[link.id]) {
      _.merge(link, ganttWorkerData.diff.linksToAdd[link.id]);
      _.merge(createdLinkMap[link.id], ganttWorkerData.diff.linksToAdd[link.id]);
    }
  });

  if (ganttWorkerData) {
    _.forOwn(ganttWorkerData.diff.tasks, (diff, taskId) => {
      if (!updatedTaskMap[taskId]) {
        updatedTaskMap[taskId] = diff;
        updatedTasksForCommit.push({ id: +taskId, ...tasksMap[taskId], ...diff });
      }

      if (tasksMap[taskId] && tasksMap[taskId].resources?.length && !refreshOverload) {
        refreshOverload = true;
      }
    });
  }

  return {
    createdLinksForCommit, updatedTasksForCommit, createdLinkMap, updatedTaskMap, refreshOverload, fromGantt,
  };
}
